import { i as e, c as r } from "../crc32-LCGpXEbE.js";
function o(t, a) {
  return t ? e.t(r.str(t).toString(), {
    defaultValue: t,
    ...a
  }) : "";
}
export {
  o as default
};
